import { FiFileText, FiPhone, FiUsers } from 'react-icons/fi';

/* The three kinds of thing you can log against a trader. Shared by the
 * trader page's activity panel and the dashboard's To do list. */
export const ACTIVITY_TYPES = [
    { key: 'note', label: 'Note', plural: 'Notes', Icon: FiFileText },
    { key: 'call', label: 'Call', plural: 'Calls', Icon: FiPhone },
    { key: 'meeting', label: 'Meeting', plural: 'Meetings', Icon: FiUsers },
];

export const typeInfo = (key) => ACTIVITY_TYPES.find((t) => t.key === key) || ACTIVITY_TYPES[0];

export const isOverdue = (a) => Boolean(a.remind_at && !a.done_at && new Date(a.remind_at) < new Date());

// "Today 14:00", "Tomorrow 09:00", "Mon 6 Oct, 09:00", "6 Oct 2027, 09:00"
export const fmtWhen = (value) => {
    const d = new Date(value);
    const now = new Date();
    const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
    const startOf = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
    const days = Math.round((startOf(d) - startOf(now)) / 86400000);
    if (days === 0) return `Today ${time}`;
    if (days === 1) return `Tomorrow ${time}`;
    if (days === -1) return `Yesterday ${time}`;
    const sameYear = d.getFullYear() === now.getFullYear();
    const date = d.toLocaleDateString('en-GB', {
        weekday: Math.abs(days) < 7 ? 'short' : undefined,
        day: 'numeric',
        month: 'short',
        year: sameYear ? undefined : 'numeric',
    });
    return `${date}, ${time}`;
};
